// import React, { useEffect } from 'react';
// import { useTranslation } from 'react-i18next';
// import i18next from 'i18next';
// import cookies from 'js-cookie';
// import { useSelector, useDispatch } from 'react-redux';
// import { togglefunction } from '../../features/togglebuttonSlice';

// const languages = [
//   {
//     code: 'ar',
//     name: 'العربية',
//     country_code: 'sa',
//     dir: 'rtl',
//   },
//   {
//     code: 'en',
//     name: 'English',
//     country_code: 'gb',
//     dir: 'ltr',
//   },
// ];

// export const LanguageSelector = () => {
//   const isActive = useSelector((state) => state.toggle.isActive);
//   const { t } = useTranslation();
//   const dispatch = useDispatch();
//   const currentLanguageCode = cookies.get('i18next') || 'en';
//   const currentLanguage = languages.find((l) => l.code === currentLanguageCode);

//   useEffect(() => {
//     const direction = isActive ? 'rtl' : 'ltr';
//     document.body.dir = direction;
//     document.title = t('app_title');
//   }, [currentLanguage, t]);
//   useEffect(() => {
//     i18next.changeLanguage('ar');
//   }, []);

//   const toggleClass = () => {
//     localStorage.setItem('isActive', !isActive);
//     dispatch(togglefunction(!isActive));
//   };

//   return (
//     // <div className="d-flex justify-content-end">
//     //   <Dropdown style={{margin: '1px 5px'}}>
//     //           <Dropdown.Toggle variant="success" id="dropdown-basic">
//     //               <i className='bi bi-globe'></i>
//     //           </Dropdown.Toggle>
//     //           <Dropdown.Menu>
//     //             <Dropdown.Item>
//     //               <span className="dropdown-item-text">{t('language')}</span>
//     //             </Dropdown.Item>
//     //             {languages.map(data =>{
//     //               <>
//     //               <Dropdown.Item key={data.country_code}>
//     //                 <button
//     //                 onClick={() => i18next.changeLanguage(`${data.code}`)}
//     //                 disabled={`${data.code}` === currentLanguageCode}>
//     //                   <span className={`flag-icon flag-icon-${data.country_code} mx-2`}
//     //                     style={{opacity: `${data.code}` === currentLanguageCode? 0.5 : 1}}
//     //                   ></span>
//     //                   {data.name}
//     //                 </button>
//     //               </Dropdown.Item>
//     //               </>
//     //             })}

//     //           </Dropdown.Menu>
//     //       </Dropdown>

//     //   <div className="dropdown">
//     //     <button
//     //       className="btn btn-secondary dropdown-toggle"
//     //       type="button"
//     //       id="dropdownMenuButton"
//     //       data-bs-toggle="dropdown"
//     //       aria-expanded="false">
//     //       <i className="bi bi-globe"></i>
//     //     </button>
//     //     <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
//     //       <li>
//     //         <span className="dropdown-item-text">{t('language')}</span>
//     //       </li>
//     //       {languages.map((item) => (
//     //         <li key={item.country_code}>
//     //           <button
//     //             className="dropdown-item"
//     //             onClick={() => {
//     //               i18next.changeLanguage(item.code);
//     //               toggleClass(); // Assuming this is a correct function name
//     //             }}
//     //             disabled={item.code === currentLanguageCode}>
//     //             <span
//     //               className={`flag-icon flag-icon-${item.country_code} mx-2`}
//     //               style={{ opacity: item.code === currentLanguageCode ? 0.5 : 1 }}></span>
//     //             {item.name}
//     //           </button>
//     //         </li>
//     //       ))}
//     //     </ul>
//     //   </div>
//     // </div>

//     // <div data-dial-init className="fixed flex w-28 start-0 end-0 bottom-12 z-20 group">
//     //   <button
//     //     type="button"
//     //     onClick={() => {
//     //       toggleClass();
//     //       i18next.changeLanguage(isActive ? 'en' : 'ar');
//     //       // i18next.changeLanguage(isActive ? 'ar' : 'en');
//     //     }}
//     //     className="flex items-center justify-center font-bold text-lg text-white bg-customgreen rounded-md w-14 h-14 hover:bg-hovergreen focus:outline-none"
//     //   >
//     //     {isActive ? 'EN' : 'ع'}
//     //   </button>
//     // </div>
//     <div data-dial-init className="fixed flex w-28 start-0 end-0 bottom-12 z-20 group">
//       <button
//         type="button"
//         onClick={() => {
//           toggleClass();
//           i18next.changeLanguage(isActive ? 'en' : 'ar');
//         }}
//         className={`flex items-center justify-center font-bold text-lg text-white bg-customgreen w-14 h-14 hover:bg-hovergreen focus:outline-none ${
//           isActive ? 'rounded-l-md rounded-r-none' : 'rounded-r-md rounded-l-none'
//         }`}
//       >
//         {isActive ? 'EN' : 'ع'}
//       </button>
//     </div>
//   );
// };

import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { togglefunction } from '../../features/togglebuttonSlice';
import i18next from 'i18next';

const languages = [
  {
    code: 'ar',
    name: 'العربية',
    country_code: 'sa',
    dir: 'rtl',
  },
  {
    code: 'en',
    name: 'English',
    country_code: 'gb',
    dir: 'ltr',
  },
];

export const LanguageSelector = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const currentLanguageCode = isActive ? 'ar' : 'en';
  const currentLanguage = languages.find((l) => l.code === currentLanguageCode);

  useEffect(() => {
    const currentLang = i18next.language;
    if (currentLang !== currentLanguageCode) {
      i18next.changeLanguage(currentLanguageCode);
    }
  }, [currentLanguageCode]);

  useEffect(() => {
    document.body.dir = isActive ? 'rtl' : 'ltr';
    document.title = t('app_title');
  }, [currentLanguage, t]);

  const toggleClass = () => {
    const newIsActive = !isActive;
    dispatch(togglefunction(newIsActive)); // also updates localStorage
  };

  return (
    <div data-dial-init className={`fixed flex  ${isActive ? 'left-0' : 'right-0'} bottom-12 z-20 group`}>
      <button
        type="button"
        // onClick={toggleClass}
        onClick={() => {
          toggleClass();
          i18next.changeLanguage(isActive ? 'en' : 'ar');
        }}
        className={`flex items-center justify-center font-bold text-lg text-white bg-customgreen w-14 h-14 hover:bg-hovergreen focus:outline-none ${
          isActive ? 'rounded-r-md rounded-l-none' : 'rounded-l-md rounded-r-none'
        }`}
      >
        {isActive ? 'EN' : 'ع'}
      </button>
    </div>
  );
};


// import React, { useEffect } from 'react';
// import { useTranslation } from 'react-i18next';
// import { useSelector, useDispatch } from 'react-redux';
// import { togglefunction } from '../../features/togglebuttonSlice';
// import i18next from 'i18next';

// const languages = [
//   {
//     code: 'ar',
//     name: 'العربية',
//     country_code: 'sa',
//     dir: 'rtl',
//   },
//   {
//     code: 'en',
//     name: 'English',
//     country_code: 'gb',
//     dir: 'ltr',
//   },
// ];

// export const LanguageSelector = () => {
//   const isActive = useSelector((state) => state.toggle.isActive);
//   const dispatch = useDispatch();
//   const { t } = useTranslation();
//   const currentLanguageCode = isActive ? 'ar' : 'en';
//   const currentLanguage = languages.find((l) => l.code === currentLanguageCode);

//   useEffect(() => {
//     const currentLang = i18next.language;
//     if (currentLang !== currentLanguageCode) {
//       i18next.changeLanguage(currentLanguageCode);
//     }
//   }, [currentLanguageCode]);

//   useEffect(() => {
//     document.body.dir = isActive ? 'rtl' : 'ltr';
//     document.title = t('app_title');
//   }, [currentLanguage, t]);

//   const toggleClass = () => {
//     const newIsActive = !isActive;
//     dispatch(togglefunction(newIsActive)); // also updates localStorage
//   };

//   return (
//     // <div data-dial-init className="fixed flex w-28 start-0 end-0 bottom-12 z-20 group">
//     //   <button
//     //     type="button"
//     //     onClick={toggleClass}
//     //     className={`flex items-center justify-center font-bold text-lg text-white bg-customgreen w-14 h-14 hover:bg-hovergreen focus:outline-none ${
//     //       isActive ? 'rounded-l-md rounded-r-none' : 'rounded-r-md rounded-l-none'
//     //     }`}
//     //   >
//     //     {isActive ? 'EN' : 'ع'}
//     //   </button>
//     // </div>

//     <div data-dial-init className={`fixed flex  ${isActive ? 'left-0' : 'right-0'} bottom-12 z-20 group`}>
//       <button
//         type="button"
//         onClick={toggleClass}
//         className={`flex items-center justify-center font-bold text-lg text-white bg-customgreen w-14 h-14 hover:bg-hovergreen focus:outline-none ${
//           isActive ? 'rounded-r-md rounded-l-none' : 'rounded-l-md rounded-r-none'
//         }`}
//       >
//         {isActive ? 'EN' : 'ع'}
//       </button>
//     </div>
//   );
// };


